import { render } from "./CustomerDetailCreditNotesTab.vue?vue&type=template&id=56cc3322"
import script from "./CustomerDetailCreditNotesTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailCreditNotesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__